import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { SigninService } from '../../../signin/signin.service';
import { FloatingSubmenuCoordinatorService } from '../../services/floating-submenu-coordinator.service';
import { ModalController } from '@ionic/angular';
import { FuelDataComponent } from 'src/app/pages/statistical/fuel-data/fuel-data.component';
import { TechnicalDataComponent } from 'src/app/pages/statistical/technical-data/technical-data.component';
import { DataManagementService } from 'src/app/pages/data-management/data-management.service';

@Component({
  selector: 'app-graphical-report-submenu',
  templateUrl: './graphical-report-submenu.component.html',
  styleUrls: ['./graphical-report-submenu.component.scss'],
})
export class GraphicalReportSubmenuComponent implements OnDestroy {
  readonly submenuId = 'graphical-report';

  showSubmenu = false;
  submenuTimeout: any;
  submenuLeft = 0;

  /** Ignore backdrop taps from the same gesture that opened the menu (mobile ghost click). */
  private ignoreBackdropCloseUntil = 0;

  private coordinatorSubscription: Subscription;

  constructor(
    public signinService: SigninService,
    public dataManagementService: DataManagementService,
    private submenuCoordinator: FloatingSubmenuCoordinatorService,
    private modalController: ModalController,
  ) {
    this.coordinatorSubscription = this.submenuCoordinator.watchActiveSubmenu().subscribe(activeId => {
      if (activeId !== this.submenuId) {
        this.hideFloatingSubmenu(true, false);
      }
    });
  }

  ngOnDestroy(): void {
    this.coordinatorSubscription?.unsubscribe();
  }

  showFloatingSubmenu(event?: MouseEvent) {
    if (event?.currentTarget) {
      const target = event.currentTarget as HTMLElement;
      const rect = target.getBoundingClientRect();
      this.submenuLeft = rect.left + rect.width / 2;
    }
    clearTimeout(this.submenuTimeout);
    this.submenuCoordinator.open(this.submenuId);
    this.showSubmenu = true;
    this.ignoreBackdropCloseUntil = Date.now() + 450;
  }

  toggleFloatingSubmenu(event?: Event) {
    event?.preventDefault();
    event?.stopPropagation();
    if (this.showSubmenu) {
      this.hideFloatingSubmenu(true);
    } else {
      this.showFloatingSubmenu(event as MouseEvent);
    }
  }

  onBackdropClick(event?: Event) {
    event?.preventDefault();
    event?.stopPropagation();
    if (Date.now() < this.ignoreBackdropCloseUntil) {
      return;
    }
    this.hideFloatingSubmenu(true);
  }

  hideFloatingSubmenu(immediate = false, notifyCoordinator = true) {
    clearTimeout(this.submenuTimeout);
    if (immediate) {
      this.showSubmenu = false;
      if (notifyCoordinator) {
        this.submenuCoordinator.closeAll();
      }
      return;
    }
    this.submenuTimeout = setTimeout(() => {
      this.showSubmenu = false;
      if (notifyCoordinator) {
        this.submenuCoordinator.closeAll();
      }
    }, 300);
  }

  async openCarburantModal(): Promise<void> {
    const modal = await this.modalController.create({
      component: FuelDataComponent,
      cssClass: 'fuel-overlay-modal',
      backdropDismiss: true,
      showBackdrop: true,
      componentProps: {
        overlayOnly: true,
      },
    });
    await modal.present();
  }

  async openTechnicalModal(): Promise<void> {
    const modal = await this.modalController.create({
      component: TechnicalDataComponent,
      cssClass: 'fuel-overlay-modal',
      backdropDismiss: true,
      showBackdrop: true,
      componentProps: {
        overlayOnly: true,
      },
    });
    await modal.present();
  }

  canShowFuelReport(): boolean {
    return this.signinService.hasVehicleFuelOption(this.dataManagementService.selectedVehicule);
  }

  canShowTemperatureReport(): boolean {
    return this.signinService.hasVehicleTemperatureOption(this.dataManagementService.selectedVehicule);
  }
}
